{
	"type": "line",
	"minzoom": 2,
	"layout": {},
	"paint": { "line-width": 3, "line-color": "#8400a8" }
}
